export default "__VITE_ASSET__BAM7qpis__"